import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface EventInfoVideo {
	vimeoNm: string;
	vimeoUrl: string;
	vimeoThum1: string;
	vimeoNote: string;
}

/** ```
 * 행사 정보 이미지 조회
 *   `/pkg/event-info/{infoId}/{type}/videos`
 * parameter
 *   `infoId` 관광지정보ID
 *   `type` 타입 ( "travel" | "hotel") default : travel
 *   `evCd?` 이벤트코드 (type === "hotel" 일경우 필요)
 * ```*/
const key = "useEventInfoVideos";
const getPath = (infoId: string, type?: "travel" | "hotel", evCd?: string): string | null => {
	if (!infoId) return null;
	if (type === "hotel" && evCd)
		return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/event-info/${infoId}/${evCd}/${type || "travel"}/videos`;
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/event-info/${infoId}/${type || "travel"}/videos`;
};

/** ```
 * 행사 정보 이미지 조회
 *   `/pkg/event-info/{infoId}/{type}/videos`
 * parameter
 *   `infoId` 관광지정보ID
 *   `type` 타입 ( "travel" | "hotel") default : travel
 *   `evCd?` 이벤트코드 (type === "hotel" 일경우 필요)
 * ```*/
const useEventInfoVideos = (
	infoId: string,
	type?: "travel" | "hotel",
	evCd?: string,
	options?: Partial<UseQueryOptions<Response<EventInfoVideo[]>, Error>>,
) =>
	useQuery({
		queryKey: [key, getPath(infoId, type, evCd)],
		queryFn: () => useConfigureAxios({url: getPath(infoId, type, evCd)}).then(r => r.data),
		staleTime: 1000 * 30 * 60,
		...options,
	});

export default useEventInfoVideos;
export {getPath};
export type {EventInfoVideo};
